import React, { useMemo, useState } from "react";
import { useIntl } from "react-intl";

import Right from "../../newUXAssets/icons/Right";
import Down from "../../newUXAssets/icons/Down";

import {
  Container,
  Header,
  Text,
  Seach,
  CustomTable,
  InputSearch,
  Empty,
  FilterContainer,
  SelectFilter,
  FilterTitle,
  FilterSection,
} from "./styles";

const DEFAULT_EXPANDABLE = () => true;

const Table = ({
  dataSource,
  title,
  height = 368,
  withFilters = false,
  filtersData = [],
  tablePagination = {},
  handleGetInfoTable = () => {},
  isDisabledSeach = false,
  haveExpandable = false,
  notEven = false,
  disabledPagination = false,
  expandedRowRender = () => {},
  rowKey = "key",
  rowExpandable,
  loading,
  ...props
}) => {
  const intl = useIntl();

  const [expandedKey, setExpandedKey] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedDoc, setSelectedDoc] = useState("all");
  const [selectedDate, setSelectedDate] = useState("all");

  const handleSetValueSearch = (value) => {
    setTimeout(() => {
      handleGetInfoTable(0, 10, value);
    }, 1000);
    setSearchValue(value);
  };

  const optionsPagination = useMemo(() => {
    if (disabledPagination) {
      return false;
    }

    return {
      simple: true,
      position: ["bottomCenter"],
      ...tablePagination,
      onChange: (page, pageSize) => {
        handleGetInfoTable(page - 1, pageSize, searchValue);
      },
    };
  }, [disabledPagination, tablePagination, handleGetInfoTable]);

  const getRowKey = (record) =>
    typeof rowKey === "function" ? rowKey(record) : record[rowKey];

  const otherProps = useMemo(() => {
    if (!haveExpandable) return props;

    return {
      ...props,
      expandable: {
        expandedRowRender,
        expandedRowKeys: expandedKey,
        // Permite controlar quais linhas podem expandir.
        // Quando retorna false, o antd não renderiza o ícone de expansão.
        rowExpandable: rowExpandable ?? DEFAULT_EXPANDABLE,
        expandIcon: ({ expanded, onExpand, record, expandable }) => {
          // Se a linha não é expansível, não renderiza ícone (mantém alinhamento via espaço vazio)
          if (!expandable)
            return <span style={{ display: "inline-block", width: 16 }} />;

          return expanded ? (
            <Down
              onClick={(e) => {
                onExpand(record, e);
                setExpandedKey([]);
              }}
            />
          ) : (
            <Right
              onClick={(e) => {
                onExpand(record, e);
                setExpandedKey([getRowKey(record)]);
              }}
            />
          );
        },
      },
    };
  }, [
    props,
    haveExpandable,
    expandedRowRender,
    expandedKey,
    rowKey,
    rowExpandable,
  ]);

  const optionsFilterDocs = [
    { value: "all", label: intl.formatMessage({ id: "all" }) },
    ...(Array.isArray(dataSource)
      ? dataSource.map((item) => ({
          value: item.fileName,
          label: item.fileName,
        }))
      : []),
  ];

  const optionsFilterDate = [
    { value: "all", label: intl.formatMessage({ id: "all" }) },
    ...(Array.isArray(dataSource)
      ? dataSource.map((item) => {
          const date = new Date(item.fileSubmissionDate);
          const formattedDate = date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          return {
            value: item.fileSubmissionDate,
            label: formattedDate,
          };
        })
      : []),
  ];

  const filteredData = useMemo(() => {
    const safeData = Array.isArray(dataSource) ? dataSource : [];

    return safeData.filter((item) => {
      const matchDoc =
        selectedDoc === "all" ? true : item.fileName === selectedDoc;

      const matchDate =
        selectedDate === "all"
          ? true
          : item.fileSubmissionDate === selectedDate;

      return matchDoc && matchDate;
    });
  }, [dataSource, selectedDoc, selectedDate]);

  return (
    <Container $notEven={notEven}>
      {(title || !isDisabledSeach) && (
        <Header>
          <Text>{title}</Text>
          {withFilters && (
            <FilterContainer>
              <FilterSection>
                <FilterTitle>
                  {intl.formatMessage({ id: "documents" }) + ": "}
                </FilterTitle>
                <SelectFilter
                  onChange={(value) => setSelectedDoc(value)}
                  defaultValue="all"
                  options={optionsFilterDocs}
                />
              </FilterSection>

              <FilterSection>
                <FilterTitle>
                  {intl.formatMessage({ id: "date" }) + ": "}
                </FilterTitle>
                <SelectFilter
                  onChange={(value) => setSelectedDate(value)}
                  defaultValue="all"
                  options={optionsFilterDate}
                />
              </FilterSection>
            </FilterContainer>
          )}
          {!isDisabledSeach && (
            <Seach>
              <InputSearch
                name="search-table"
                type="seach"
                placeholder={intl.formatMessage({ id: "search" })}
                onChange={({ target }) => handleSetValueSearch(target.value)}
              />
            </Seach>
          )}
        </Header>
      )}
      <CustomTable
        loading={loading}
        dataSource={filteredData}
        rowKey={rowKey}
        $isEmpty={filteredData?.length === 0}
        $notEven={notEven}
        locale={{
          emptyText: (
            <Empty>{intl.formatMessage({ id: "no_results_to_display" })}</Empty>
          ),
        }}
        scroll={{
          x: "100%",
          y: height,
        }}
        pagination={optionsPagination}
        {...otherProps}
      />
    </Container>
  );
};

export default Table;
